﻿import FileName from "../utilities/filename";

export class BuildsExtensionIcon {
  private map = [
    { className: 'icon-file-pdf', fileTypes: ['pdf'] },
    { className: 'icon-file-word', fileTypes: ['doc', 'dot', 'docx', 'docm', 'dotx', 'dotm', 'docb'] },
    { className: 'icon-file-excel', fileTypes: ['xln', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm', 'xlw'] },
    { className: 'icon-file-audio', fileTypes: ['aif', 'iff', 'm3u', 'm4a', 'mid', 'mp3', 'mpa', 'ra', 'wav', 'wma'] },
    { className: 'icon-file-video', fileTypes: ['3g2', '3gp', 'asf', 'asx', 'avi', 'flv', 'm4v', 'mov', 'mp4', 'mpg', 'rm', 'srt', 'swf', 'vob', 'wmv'] },
    { className: 'icon-file-image', fileTypes: ['bmp', 'dds', 'gif', 'jpg', 'jpeg', 'png', 'psd', 'pspimage', 'tga', 'thm', 'tif', 'tiff', 'yuv'] },
    { className: 'icon-file-text', fileTypes: ['log', 'msg', 'odt', 'pages', 'rtf', 'tex', 'txt', 'wpd', 'wps', 'dat'] },
  ];

  public execute(filename: string): string {
    if (!filename)
      return null;

    let extension = new FileName(filename).extension();

    for (let i = 0; i < this.map.length; i++) {
      for (let j = 0; j < this.map[i].fileTypes.length; j++) {
        if (this.map[i].fileTypes[j] === extension)
          return this.map[i].className;
      }
    }
    return 'icon-file-default';
  }
}

export default BuildsExtensionIcon;